import TableBody from './components/TableBody';
import TableCell from './components/TableCell';
import TableCellButton from './components/TableCellButton';
import TableFooter from './components/TableFooter';
import TableHead from './components/TableHead';
import TableHeader from './components/TableHeader';
import TableRoot from './components/TableRoot';
import TableRow from './components/TableRow';

export const Table = {
	Root: TableRoot,
	Header: TableHeader,
	Body: TableBody,
	Footer: TableFooter,
	Head: TableHead,
	Row: TableRow,
	Cell: TableCell,
	CellButton: TableCellButton
};
